// Pure, testable adapter for the existing BPA Email Gateway universal form.
// Never sends private API keys to the browser. The server controls mail routing.
const CORE_KEYS = ['name','organisation','email','phone','message'];

export function buildUniversalEnquiry({data,interest,formFields,submissionId,startedAt}) {
  const spec = Array.isArray(formFields) ? formFields : [];
  // Prevent a silently broken submission if the Gateway form gains a required field
  // that is not represented on this landing page.
  const known = new Set([...CORE_KEYS, 'interest']);
  const unknownRequired = spec.find(f => f?.required === true && !known.has(f.key));
  if (unknownRequired) {
    throw new Error('The enquiry form now requires an additional field. Please email support@bpasolutions.au while we update the website.');
  }
  const hasInterest = spec.some(f => f?.key === 'interest');
  const category = String(interest || '').trim();
  const message = String(data.message || '').trim();
  // The current five-field PocketBase form has no interest field. Preserve it in
  // the message so the business and acknowledgement emails contain the category.
  const combinedMessage = hasInterest
    ? message
    : ['Area of interest: ' + category, message].filter(Boolean).join('\n\n');
  const messageDefinition = spec.find(f=>f?.key==='message');
  const max = Number(messageDefinition?.max) || 2000;
  if (combinedMessage.length > max) {
    throw new Error('Please shorten your message slightly so we can include your area of interest without losing information.');
  }
  const fields = {
    name: String(data.name || '').trim(),
    organisation: String(data.organisation || '').trim(),
    email: String(data.email || '').trim().toLowerCase(),
    phone: String(data.phone || '').trim(),
    message: combinedMessage
  };
  if (hasInterest) fields.interest = category;
  return {
    submissionId,
    startedAt,
    fields,
    marketingConsent: data.marketingConsent === true,
    website: String(data.website || '')
  };
}